const SET_PROPERTY_HOSTINGS = 'hosting/SET_PROPERTY_HOSTINGS';
const CREATE_PROPERTY_HOSTING_ASYNC = 'hosting/CREATE_PROPERTY_HOSTING_ASYNC';
const DELETE_PROPERTY_HOSTING_ASYNC = 'hosting/DELETE_PROPERTY_HOSTING_ASYNC';

export const HOSTING_ACTION_TYPES = {
  SET_PROPERTY_HOSTINGS,
  CREATE_PROPERTY_HOSTING_ASYNC,
  DELETE_PROPERTY_HOSTING_ASYNC,
};
